export const version = '20241127-97f2dfd97'
